import React from "react";

const InputSearch: React.FC = () => {
  return (
    <>
      <div
        className="collapse input-group mb-3"
        id="collapseExample"
        style={{ transition: "0.5s" }}
      >
        <input type="text" className="form-control" placeholder="Procurar.." />
      </div>
    </>
  );
};

export default InputSearch;
